import {computed, ref} from "vue";
import {SortDirection, SortingParameter} from "@/api/TenantAPIClient";

export interface SortItem {
    key: string;
    order: 'asc' | 'desc';
}

export interface UseSortDefaults {
    sort?: SortItem[]
}

export const useSort = (defaults?: UseSortDefaults) => {

    const sort = ref<SortItem[]>(defaults?.sort ?? []);

    const apiSort = computed<SortingParameter[]>(() => {
        return sort.value.map((item) => new SortingParameter({
            property: item.key,
            direction: item.order === 'asc' ? SortDirection.Ascending : SortDirection.Descending
        }))
    })

    const setSort = (value: SortItem[]) => {
        sort.value = value;
    }

    return {
        sort,
        apiSort,
        setSort
    }
}
